import type { ReactNode } from 'react'
import { MinimalDatePicker } from '@ovasabi/ui-minimal'
import { toLocalDateKey } from '../../lib/scheduling'

/**
 * Chow-local plain-date adapter around the Foundation date picker. The shared
 * primitive owns field copy, popover behavior, constraints, and calendar A11y;
 * this wrapper owns the app's stable `YYYY-MM-DD` serialization contract.
 */
export interface DatePickerFieldProps {
  value: string
  onChange: (next: string) => void
  label?: ReactNode
  hint?: ReactNode
  locale?: string
  weekStartsOn?: 0 | 1
  minDate?: Date | string | null
  maxDate?: Date | string | null
  isDateDisabled?: (date: Date) => boolean
  disabled?: boolean
  /** Map the picked day to the value we store (e.g. snap to a Monday). */
  normalize?: (picked: Date) => string
}

export const DatePickerField = ({
  value,
  onChange,
  label = 'Date',
  hint,
  locale = 'en-NG',
  weekStartsOn = 1,
  minDate,
  maxDate,
  isDateDisabled,
  disabled,
  normalize,
}: DatePickerFieldProps) => (
  <MinimalDatePicker
    label={label}
    hint={hint}
    value={value}
    minDate={minDate}
    maxDate={maxDate}
    isDateDisabled={isDateDisabled}
    disabled={disabled}
    locale={locale}
    weekStartsOn={weekStartsOn}
    onChange={(next) => {
      if (!next) {
        onChange('')
        return
      }
      onChange(normalize ? normalize(next) : toLocalDateKey(next))
    }}
  />
)
